import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { ContratistaEntity, ContratosEntity, ContratosExcel, BuscaContratista } from "../entities/contratistas_entity";
import { ContratoSegurosEntity } from '../entities/contrato_seguros_entity';


declare var jQuery: any;

@Injectable()

export class ContratoSegurosService {
    private url = "contratoseguros";
    userEmpresa: ClienteXCiudad;

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultarListContratos(userEmpresa: ClienteXCiudad): Observable<ContratoSegurosEntity[]> {
        let body = JSON.stringify(userEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarContratosSeguros", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/contratoSeguros/contrato-seguros.service.ts